import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { UserResponseModal } from "../models/User";
import { environment } from "../../environments/environment";
import { AuthPayload } from "../engine/models/models";
import { Router } from "@angular/router";
import { Globals } from "./globals";
import { ClientConfiguratioService } from "./client-configuration.service";
import { SessionType } from "../enum";

@Injectable({ providedIn: "root" })

export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<UserResponseModal>;
  public currentUser: Observable<UserResponseModal>;
  userData = new BehaviorSubject<AuthPayload>(new AuthPayload());

  constructor(
    private clientConfiguratioService: ClientConfiguratioService,
    public globals: Globals,
    private router: Router,
    private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<UserResponseModal>(JSON.parse(localStorage.getItem("currentUser")));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): UserResponseModal {
    return this.currentUserSubject.value;
  }

  login(loginModel: AuthPayload): Observable<AuthPayload> {
    return this.http.post<AuthPayload>(`${environment.api}/api/authentication`, loginModel);
  }

  clientStage(id: number) {
    return this.http.get<any>(`${environment.api}/api/authentication/${id}`);
  }

  logout() {
    if (!this.globals.isImpersonating && !this.globals.isUserAdmin) {
      this.clientConfiguratioService.UpdateClientSession(this.globals.appointment.contractId, SessionType.Logout).subscribe();
    }
    let userEmail = localStorage.getItem("userEmail");
    sessionStorage.clear();
    localStorage.clear();
    this.globals.selectedArea = undefined;
    this.globals.clearAppointment();
    this.globals.engine = null;
    sessionStorage.removeItem("currentUser");
    this.currentUserSubject.next(null);
    localStorage.removeItem('authToken');
    localStorage.setItem("userEmail", userEmail);
    this.router.navigate(['/login']);
    this.userData.next(new AuthPayload());
  }
}
